module.exports = __webpack_public_path__ + "static/media/card_bg_8.0ed2486f.png";